// Styles
import { concatStyleSets, memoizeFunction, mergeStyles } from "@fluentui/react";
import { FontSizes, FontWeights } from "@fluentui/react";
import { backgroundColorNeutralSecondaryAlt, flexParent, fontColorNeutralPrimary, fontColorThemePrimary, lateBackgroundColorStyles, lateColorStyles } from "../../../utilities/Mixin.styles";
import { getDatePickerStyles } from "../datePicker/DatePicker.styles";
// Utilities
import { isLoopTheme } from "../../../utilities/ThemingUtilities";
/**
 * DueDateIndicator Style constants
 */ const buttonPadding = "2px";
const calendarIconPaddingLeft = "2px";
const dueDateButtonBorderRadius = "2px";
const dueDateButtonBorderRadiusLoop = "4px";
const indicatorPaddingRight = "8px";
/**
 * Helper to get styles for the DueDateIndicator
 * @param theme The theme to render the control
 * @param customStyles Any custom style overrides
 */ export const getStyles = memoizeFunction((theme, customStyles)=>{
    const isThemeForLoop = isLoopTheme(theme);
    const dueDateIndicatorStyles = {
        root: [
            flexParent(),
            {
                display: "inline-flex",
                alignItems: "center",
                height: "24px",
                cursor: "default",
                "&.clickable": {
                    borderRadius: dueDateButtonBorderRadius,
                    cursor: "pointer"
                },
                "&.clickable:hover": backgroundColorNeutralSecondaryAlt(theme),
                "&.isLate": [
                    lateBackgroundColorStyles(theme),
                    {
                        borderRadius: isThemeForLoop ? dueDateButtonBorderRadiusLoop : dueDateButtonBorderRadius,
                        transition: "background 0.167s ease-in-out",
                        "> .plannerIcon,.label": lateColorStyles(theme)
                    }
                ]
            }
        ],
        calendarIcon: [
            isThemeForLoop ? fontColorNeutralPrimary(theme) : fontColorThemePrimary(theme),
            {
                paddingLeft: calendarIconPaddingLeft,
                paddingRight: buttonPadding
            }
        ],
        calendarLabel: [
            fontColorNeutralPrimary(theme),
            {
                fontSize: FontSizes.small,
                fontWeight: FontWeights.regular,
                paddingLeft: buttonPadding,
                paddingRight: indicatorPaddingRight
            }
        ],
        callout: getDatePickerStyles(theme).callout
    };
    return concatStyleSets(dueDateIndicatorStyles, customStyles);
});
/**
 * Get the classnames associated with the computed styles for the DueDateIndicator component
 * @param styles The styles for the component
 */ export const getClassNames = memoizeFunction((styles)=>{
    return {
        root: mergeStyles("dueDateIndicator", styles.root),
        calendarIcon: mergeStyles("calendarIcon", styles.calendarIcon),
        calendarLabel: mergeStyles("calendarLabel", styles.calendarLabel),
        callout: mergeStyles("dueDateIndicatorCallout", styles.callout)
    };
});
